import { render } from "./KSFromDomains.vue?vue&type=template&id=3c2f0e22"
import script from "./KSFromDomains.vue?vue&type=script&lang=js"
export * from "./KSFromDomains.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__